<template>
  <div class="wrapper-bar-4">
    <div class="container-card">
      <router-link
        :to="
          $i18nRoute({
            name: 'NewsDetail',
            params: { slug: item.url }
          })
        "
        v-for="(item, index) in list"
        :key="item.id"
        class="card"
        :class="`card-${index + 1}`"
      >
        <div class="card__descr">
          <div class="card__category">
            {{ item.sub_category.name }}
          </div>
          <div class="card__title limited-text">{{ item.title }}</div>
          <div class="data-news">
            <span class="day">{{ handleDate(item.pub_date) }},</span>
            <span class="time">{{ handleTime(item.pub_date) }}</span>
          </div>
        </div>
        <div class="neon"></div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { useFormatter } from "@/utils/formatter";

export default {
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup() {
    return {
      ...useFormatter()
    };
  }
};
</script>

<style lang="scss" scoped>
.wrapper-bar-4 {
  background: url("../../../assets/lifestyle-page/mob-fourth-bg.jpg") no-repeat
    top center;
  background-size: 120%;
  width: 100%;
  padding: 5rem 0;
}
.container-card {
  width: 80%;
  margin: 0 auto;
}
.card {
  &__descr {
    padding: 1rem 0;
  }
}
.card-5 {
  .neon {
    display: none;
  }
}
.neon {
  position: relative;
  width: 105%;
  height: 3px;
  transform: translateX(-2.5%);
  border-radius: 1.5px;
  background: linear-gradient(
    90deg,
    rgba(255, 0, 0, 1) 9%,
    rgba(255, 188, 0, 1) 22%,
    rgba(255, 226, 0, 1) 37%,
    rgba(22, 255, 0, 1) 52%,
    rgba(0, 146, 255, 1) 66%,
    rgba(0, 31, 255, 1) 81%,
    rgba(186, 0, 236, 1) 100%
  );
  background-size: 400%, 400%;
  animation: animateCard 10s ease-out alternate infinite;

  &::before {
    width: 100%;
    height: 2px;
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    background: linear-gradient(
      90deg,
      rgba(255, 0, 0, 1) 9%,
      rgba(255, 188, 0, 1) 22%,
      rgba(255, 226, 0, 1) 37%,
      rgba(22, 255, 0, 1) 52%,
      rgba(0, 146, 255, 1) 66%,
      rgba(0, 31, 255, 1) 81%,
      rgba(186, 0, 236, 1) 100%
    );
    filter: blur(5px);
    background-size: 400%, 400%;

    z-index: 2;
    animation: animateCard 10s ease-out alternate infinite;
  }
}
@media screen and (max-width: 767px) {
  .wrapper-bar-4 {
    background-size: 120% 100%;
  }
  .card {
    &__category {
      color: rgba(255, 255, 255, 0.7);
      font-weight: normal;
      font-size: 12px !important;
      line-height: 16px;
    }
  }
}
</style>
<style lang="scss">
@keyframes animateCard {
  0% {
    background-position: 0 50%;
  }
  25% {
    background-position: 50% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  75% {
    background-position: 50% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
</style>
